<template>
    <div class="container">
        <div class="meet-level trans">
            <meet-header
                :headerConfig="headerConfig"
                @handleClickIocn="handleClickIocn"
            />

            <div class="main">
                <h2 class="tit">温馨提示</h2>
                <RichHtml
                style="margin-left: 4px; margin-right: 4px"
                :content="hint"
                ></RichHtml>
                <!-- <div class="details shadow" >{{hint}}</div> -->
            </div>
        </div>
    </div>
</template>

<script>
import meetHeader from "@/components/header";
import RichHtml from "@/components/RichHtml"
import CurrentConferMixin from "@/mixin/CurrentConference"
export default {
    name: "meetLevel",
    components: {
        meetHeader,
        RichHtml
    },
    mixins: [CurrentConferMixin],
    data() {
        return {
            headerConfig: {
                headerIcon: "city ct-xiangyou",
                headerTitle: "详细信息",
            },
            hint:"暂无温馨提示"
        };
    },
    async created(){
        await this.$store.dispatch("conference/getCurrentConference")
        this.hint = this.currentConference.notices[1].notice
    },
    methods: {
        handleClickIocn() {
            this.$router.go(-1)
            // history.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    box-sizing: border-box;

    .tit {
        padding-left: 8px;
        margin-top: 30px;
        border-left: 4px solid var(--main-color);
        font-size: 18px;
        font-weight: bold;
        color: var(--main-color);
    }

   
    .details {
        width: 100%;
        margin-top: 30px;
        font-size: 14px;
        padding: 15px;
        line-height: 28px;
        color: #666;
        border-radius: 5px;
        box-sizing: border-box;
    }
}
</style>